import React, { useState, useCallback } from 'react';
import axios from 'axios';
// import classnames from 'classnames';

// import { SendForm } from 'api/forms';

import WebinarFormElem from './components/FormElem';

import { wrap } from './styles.module.scss';

const WebinarOnDemandForm = ({ data, lang, allowVideo }) => {
  const [seccess, setSuccess] = useState(false);

  //TODO: Create custom event
  const createWebinarOnDemandSubmitEvent = () => {
    typeof window !== 'undefined' &&
      window.dataLayer !== 'undefined' &&
      window.dataLayer.push({ event: 'webinar_on_demand_submit' });
  };

  // TODO: API for google sheets data send
  const emailToGoogleSheet = useCallback((values) => {
    axios
      .post(
        'https://sheet.best/api/sheets/9d7e728b-7f3c-427b-88d2-5e749e8c42aa',
        values
      )
      .then((response) => {
        console.info('form send');
      });
  }, []);

  const handleSubmit = (values) => {
    // TODO: emailJs send form
    // SendForm(values, 'webinar_form');

    emailToGoogleSheet(values);
    createWebinarOnDemandSubmitEvent();
    // console.info(values, 'webinar_on_demand_form');

    allowVideo();
    setSuccess((state) => !state);
  };

  return (
    <div className={wrap}>
      {!seccess && (
        <WebinarFormElem
          data={data}
          onSubmit={(values) => handleSubmit(values)}
          lang={lang}
        />
      )}
    </div>
  );
};

export default WebinarOnDemandForm;
